export default [
  {
    path: 'profit-loss',
    redirect: 'profit-loss/by-bill',
  },
  {
    path: 'profit-loss/by-bill',
    name: 'report-bill-revenue',
    component: () => import('@/view/pages/reports/bill-revenue-report/ListBillRevenueReport.vue'),
    meta: {
      title: 'Báo cáo lãi lỗ theo hoá đơn - CLICKBUY',
    },
  },
]

